/*
User Page
*/
import React, { useEffect } from "react";
import Account from ".//..//..//..//assets//images//icons//account.svg";
import InputTextSimple from "../../../components/common/InputText/InputTextSimple";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import FelhasznaloHozzaadasa from "./FelhasznaloHozzaadasa";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import { useState } from "react";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import useAuth from "../../../hooks/useAuth";

const Felhasznalo = () => {
  // const { getAuthToken } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [isNewUserCreated, setIsNewUserCreated] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const { getAuth, clearAuth } = useAuth();

  const navigate = useNavigate();

  const fetchUsers = () => {
    HttpHelper.GetRequest({
      route: API_ROUTES.USER_LIST,
      token: getAuth()?.bearerToken,
      searchQuery: searchQuery,
    })
      .then((data) => {
        if (data.status == 200) {
          setUsers(data?.data?.users);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [isNewUserCreated]);

  useEffect(() => {
    const delayedFetchUsers = setTimeout(() => {
      fetchUsers();
    }, 500); // 500 mili seconds delay

    return () => clearTimeout(delayedFetchUsers);
  }, [searchQuery]);
  return (
    <>
      <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem]  flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
        <Link to={ROUTES.ADMIN_HOME}>
          <img src={Account} alt="account icon" className="w-[3rem] sm:w-[4.35rem] " />
        </Link>
        <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Felhasználók</h2>
      </div>

      <div className="mt-[3rem] flex flex-col lg:flex-row  gap-12 ">
        {/* Table */}
        <div className="order-2 w-full lg:order-1 lg:w-1/2">
          <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem] ">
            <div className="w-full mb-4 lg:w-3/4">
              <InputTextSimple
                placeholder={`Felhasználó keresése`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="overflow-x-auto ">
            <div className="px-[1rem] sm:px-[1.875rem] overflow-y-auto ">
              {/* Header End */}
              <div className="p-3 min-w-[30rem] w-full grid grid-cols-[1fr_1fr_3rem] cursor-pointer mb-5  ">
                <span className="inline-block font-bold ps-7">Név</span>
                <span className="inline-block font-bold">Email</span>
                <span className="inline-block"></span>
              </div>
              {/* Body Start */}
              <div className="h-[32rem]">
                {users.map((user, index) => {
                  return (
                    <div
                      key={index}
                      className="p-3 min-w-[30rem] w-full grid grid-cols-[1fr_1fr_3rem] cursor-pointer transition-bg ease-in-out duration-100 hover:bg-[#e6eef0] bg-[#FAF8F8] mb-5 rounded-[0.625rem] shadow-[0_4px_4px_0_rgba(16,16,16,0.1)]"
                    >
                      <span className="inline-block ps-7">{user.name}</span>
                      <span className="inline-block ">{user.email}</span>
                      <span className="inline-block mx-auto cursor-pointer ">
                        <Link to={`${ROUTES.ADMIN_USER_MANAGE}?id=${user.id}`} state={{ user }}>
                          <i className="ri-pencil-fill p-1.5"></i>
                        </Link>
                      </span>
                    </div>
                  );
                })}
              </div>
              {/* Body End */}
            </div>
          </div>
        </div>

        {/* Form  - Create New User */}
        <FelhasznaloHozzaadasa setIsNewUserCreated={() => setIsNewUserCreated(true)} />
      </div>
    </>
  );
};

export default Felhasznalo;
